import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import data from '../../data/index.json';

export default function MySkills() {
    const [emblaRef, emblaApi] = useEmblaCarousel({ 
        loop: true, 
        align: 'center',
        skipSnaps: false,
        slidesToScroll: 1
    });

    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    return (
        <section className="skills--section" id="mySkills">
            <div className="skills--container">
                <p className="skills-section--title">My Skills</p>
                <h2 className="skills--section--heading">My Expertise</h2>
            </div>
            
            <div className="embla">
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container">
                        {data?.skills?.map((item, index) => (
                            <div key={index} className="embla__slide">
                                <div className="skills--section--card">
                                    <div className="skills--section--img">
                                        <img src={item.src} alt={item.title} />
                                    </div>
                                    <div className="skills--section--card--content">
                                        <h3 className="skills--section--title">{item.title}</h3>
                                        <p className="skills--section--description">{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                
                <button className="embla__prev" onClick={scrollPrev} aria-label="Previous slide">
                    <ChevronLeft size={24} />
                </button>
                <button className="embla__next" onClick={scrollNext} aria-label="Next slide">
                    <ChevronRight size={24} />
                </button>
            </div>
        </section>
    );
}
